export const ROUTES = {
  confirm: '/confirm-reservation',
  reservation: '/reservation-status',
  homeDetails: '/details',
  inventory: '/home-inventory',
  landingPage: '/start',
  offers: '/browse-quotes',
  scheduleEstimate: '/schedule-estimate',
  requestEstimateStatus: '/request-estimate-status',
  error: '/error',
  requestEstimates: '/request-estimates',
  requestEstimatesConfirmation: '/request-estimates-confirmation',
  requestFreeEstimates: '/request-free-estimates',
  choose: '/choose',
  homeSize: '/home-size',
  survey: '/survey',
  diyTruck: '/diy-truck',
  diyPackingMaterials: '/diy-packing-materials',
  diyPackingKit: '/diy-packing-kit',
  diyLabor: '/diy-labor',
  diyLaborOptions: '/diy-labor-options',
  diyAutoShip: '/diy-auto-shipping',
  diyAutoShipDetails: '/diy-auto-ship-details',
  diyFinalKit: '/diy-final-kit',
};

export const STATUSES = {
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  CONFIRMED: 'confirmed',
  RESERVED: 'reserved',
  REQUESTED: 'requested',
  STARTED: 'started',
};

export const STEP_LIST = [
  {
    name: 'Home Details',
    description: 'Answer a few questions about your old and new homes.',
    time: 'Takes ~1 min',
  },
  {
    name: 'Home Inventory',
    description: 'Easily create an inventory of the items you need moved.',
    time: 'Takes ~3 min',
  },
  {
    name: 'Browse Quotes',
    description: 'Get real-time quotes and reserve for your moving day.',
    time: 'Takes ~1 min',
  },
];

export const HOME_AREAS = [
  'BED',
  'DINING',
  'LIVING',
  'BATH',
  'OFFICE',
  'OTHER',
];

export const HOME_AREA_MAP = {
  BED: 'Bedroom',
  DINING: 'Dining Room',
  LIVING: 'Living Room',
  BATH: 'Bathroom',
  OFFICE: 'Office',
  OTHER: 'Other',
};

export const MOVE_TYPES = {
  LOCAL: 'LOCAL',
  INTRASTATE: 'INTRASTATE',
  INTERSTATE: 'INTERSTATE',
};

export const ENVS = {
  DEMO: 'demo',
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  STAGING: 'staging',
  TEST: 'test',
  UPDATRON: 'updatron',
};

export const HOME_SIZES = {
  STUDIO: 'STUDIO',
  ONE_BEDROOM: 'ONE_BEDROOM',
  TWO_BEDROOM: 'TWO_BEDROOM',
  THREE_BEDROOM: 'THREE_BEDROOM',
  // THREE_BEDROOM_PLUS: 'THREE_BEDROOM_PLUS', // TODO: which one?
};

export const OPTIONS = {
  homeSize: [
    { label: 'Studio', value: HOME_SIZES.STUDIO },
    { label: '1 Bedroom', value: HOME_SIZES.ONE_BEDROOM },
    { label: '2 Bedrooms', value: HOME_SIZES.TWO_BEDROOM },
    { label: '3 or more bedrooms', value: HOME_SIZES.THREE_BEDROOM },
  ],
  elevators: [
    { label: 'No, my home is on the ground floor', value: 'null' },
    { label: "No, there's an elevator", value: true },
    { label: 'Yes, the movers will use stairs', value: false },
  ],
  stairCount: [
    { label: '1 flight', value: 1 },
    { label: '2 flights', value: 2 },
    { label: '3 flights', value: 3 },
    { label: '4 flights', value: 4 },
    { label: '5 or more flights', value: 5 },
  ],
  distanceToCurb: [
    { label: 'Right out front (within 75 feet)', value: 'FT_75' },
    { label: 'On my block (within 150 feet)', value: 'FT_150' },
    { label: 'Down the street (within 225 feet)', value: 'FT_225' },
    { label: 'Further (more than 225 feet)', value: 'FT_300' },
    { label: `I'm not sure`, value: 'UNSURE' },
  ],
};

export const HOME_SIZE_MAP = {
  [HOME_SIZES.STUDIO]: 'studio',
  [HOME_SIZES.ONE_BEDROOM]: '1-bedroom',
  [HOME_SIZES.TWO_BEDROOM]: '2-bedroom',
  [HOME_SIZES.THREE_BEDROOM]: '3+ bedroom',
};

export const HOME_SIZE_SIMPLE_OPTIONS = [
  { label: 'Studio', value: HOME_SIZES.STUDIO },
  { label: '1BR', value: HOME_SIZES.ONE_BEDROOM },
  { label: '2BR', value: HOME_SIZES.TWO_BEDROOM },
  { label: '3BR+', value: HOME_SIZES.THREE_BEDROOM },
];

export const APP_SOURCES = {
  PROFILE: 'ProfileWidget',
  COBRANDED: 'Widget',
  IFRAME: 'iFrame',
  MOVEIQ: 'MoveIQ',
  UNKNOWN: 'Unknown',
};

export const DIY_ROUTE_SEQUENCE = [
  ROUTES.diyTruck,
  ROUTES.diyLabor,
  ROUTES.diyAutoShip,
];
